import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "@/lib/apiClient";

export const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/dashboard";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate(next);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[80vh] items-center justify-center px-6">
      <div className="w-full max-w-sm rounded-lg border border-surface-border bg-surface-card p-8 fade-up">
        <h1 className="mb-6 font-heading text-2xl font-bold text-white">Welcome back</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <Input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="border-surface-border bg-obsidian text-white" data-testid="login-email-input" />
          <Input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="border-surface-border bg-obsidian text-white" data-testid="login-password-input" />
          {error && <p className="text-sm text-sovereign" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full bg-sovereign text-white hover:bg-sovereign/90" data-testid="login-submit-btn">
            {loading ? "Logging in..." : "Log in"}
          </Button>
        </form>
        <p className="mt-3 text-center text-sm">
          <Link to="/forgot-password" className="text-slate-500 hover:text-sovereign" data-testid="login-forgot-password-link">Forgot password?</Link>
        </p>
        <p className="mt-4 text-center text-sm text-slate-500">
          No account? <Link to="/register" className="text-sovereign" data-testid="login-register-link">Sign up</Link>
        </p>
      </div>
    </div>
  );
};
